<template>
  <div>
    <!-- 001 Title 섹션 -->
    <div class="my-schedule-top-area" :class="{ 'sticky': isScrollStart }">
      <div class="my-schedule-sub-area">
        <b-dropdown right :text="getTextOfOptions(mySchedule.status)" variant="outline-secondary" size="lg"
          class="btn-select-status" :class="getStatusClass(mySchedule.status)">
          <b-dropdown-item v-for="option in statusOptions" :key="option.value" :value="option.value"
            @click="mySchedule.status = option.value">{{
              option.text
            }}
          </b-dropdown-item>
        </b-dropdown>
        <!-- Subordinate To 채터 슬롯 -->
        <b-collapse id="collapse-4" v-model="isRelationCoallapseVisible" class="">
          <b-form-row v-if="mySchedule.subordinateTo != null && mySchedule.subordinateTo.length > 0">
            <template v-for="subordinateTo in mySchedule.subordinateTo">
              <div :key="subordinateTo.myScheduleId"
                class="d-flex justify-content-between align-items-center subordinate-item">
                <span class="custom-listTextstyle" @click="showOtherMyScheduleDetail(subordinateTo.myScheduleId)"
                  style="cursor: pointer;" v-b-tooltip.hover :title="subordinateTo.title">
                  <!-- 아이디 표시 추가 -->
                  <span class="subordinate-id">{{ subordinateTo.myScheduleId }}</span>
                  {{ subordinateTo.title }}</span>
                <div class="badge-container">
                  <b-badge class="btn status-tag" variant="primary" :disabled="true">{{ subordinateTo.status |
                    formatStatus }}
                  </b-badge>
                  <b-badge variant="danger" class="btn btn-delete"
                    @click="removeObj('subordinateTo', subordinateTo.myScheduleId)">Delete
                  </b-badge>
                </div>
              </div>
            </template>
          </b-form-row>
          <b-form-row v-else>
            <b-button @click="openModal('subordinateToTable')" class="custom-input btn-add-my-schedule"
              style="display: flex; align-items: center; justify-content: center; position: relative; width:100%;"
              variant="outline-info">
              <div style="display: flex; align-items: center;">
                <!-- <b-icon-tags class="h1 mt-2"
                             icon="search"
                             variant="info"
                             style="position: relative;"
                             v-b-tooltip.hover
                             title="Add MySchedule"></b-icon-tags> -->
                <!-- 신규 아이콘 추가 -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 10H15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10 15L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span style="margin-left: 10px;">Add a Subordinate To My Schedule</span>
              </div>
            </b-button>
          </b-form-row>
        </b-collapse>
        <!-- /Subordinate To 채터 슬롯 -->
      </div>
      <!-- 신규 마크업 추가 - 스크롤 시 제목 표시 -->
      <div class="title-area" v-if="isScrollStart">
        <span class="title">{{ mySchedule.title }}</span>
      </div>
    </div>
    <!-- b-card inline-style 삭제 -->
    <b-card>
      <div class="card-header">
        <button type="button" class="btn-card-fold" :class="{ 'fold': isCardFold['title'] }"
          @click="handleCardFold('title')"></button>
        <b-form-row>
          <b-col cols="2">
            <!-- button -> span으로 마크업 변경 -->
            <span class="my-schedule-id">{{ mySchedule.myScheduleId }}</span>
          </b-col>
        </b-form-row>
        <!-- 타이틀 영역 -->
        <div class="title-wrap">
          <b-form-row class="align-items-end">
            <b-col cols="9">
              <b-input-group>
                <b-form-input name="title" label="Title" id="title" placeholder="Title" size="xl" class="my-0"
                  style="height: 45px; font-size: 30px; border:none;" v-model="mySchedule.title" ref="title"
                  v-validate="{ required: true }" :state="validateState('title')"></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
          <!-- SuperiorTo 리스트-->
          <b-collapse id="collapse-4" v-model="isRelationCoallapseVisible" class="">
            <b-form-row v-if="mySchedule.superiorTo != null && mySchedule.superiorTo.length > 0">
              <b-col>
                <b-form-group>
                  <div class="superior-list">
                    <template v-for="subordinateTo in mySchedule.superiorTo">
                      <div :key="subordinateTo.myScheduleId"
                        class="d-flex justify-content-between align-items-center superior-item">
                        <span class="custom-listTextstyle" @click="showOtherMyScheduleDetail(subordinateTo.myScheduleId)"
                          style="cursor: pointer;" v-b-tooltip.hover :title="subordinateTo.title">
                          <!-- 아이디 표시 추가 -->
                          <span class="superior-id">{{ subordinateTo.myScheduleId }}</span>
                          {{ subordinateTo.title }}
                        </span>
                        <div class="badge-container">
                          <b-badge class="btn status-tag" variant="primary" :disabled="true">{{
                            subordinateTo.status | formatStatus
                          }}
                          </b-badge>
                        </div>
                      </div>
                    </template>
                  </div>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-collapse>
          <!-- /SubordinateTo 리스트-->
        </div>
      </div>
      <div class="card-body border-top" :class="isCardFold['title'] ? 'fold' : ''">
        <!-- / 001 Title 섹션 -->
        <!-- Spinner -->
        <loading :active.sync="loading"></loading>
        <!-- /Spinner -->
        <!-- Title -->
        <b-form-group v-show="false">
          <b-form-input id="title" name="title" type="text" v-model="mySchedule.title"></b-form-input>
        </b-form-group>
        <!-- /Title -->
        <b-col cols="2">
          <!-- Status -->
          <b-form-group v-if="false">
            <label for="status">Status <span class="required">*</span></label>
            <b-form-select id="status-list" name="status" size="sm" :options="statusOptions" v-model="mySchedule.status"
              v-validate="{ required: true }" :state="validateState('status')" class="custom-select"></b-form-select>
            <b-form-invalid-feedback id="status-feedback">
              {{ errors.first('status') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- /Status -->
        </b-col>
        <b-form v-if="this.mySchedule">
          <b-form-row>
          </b-form-row>
          <div class="form-wrap border-bottom">
            <b-form-row>
              <b-col cols="3">
                <label for="Priority">Priority</label>
                <!-- Priority -->
                <b-form-group>
                  <b-form-select id="Priority-list" name="Priority" size="sm" :options="priorityOptions"
                    v-model="mySchedule.priority" class="custom-select"></b-form-select>
                  {{ errors.first('Priority') }}
                  <b-form-invalid-feedback id="Priority-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- /Priority -->
              </b-col>
              <b-col cols="3">
                <label for="level">Level</label>
                <!-- level -->
                <b-form-group>
                  <b-form-select id="level-list" name="level" size="sm" :options="levelOptions" v-model="mySchedule.level"
                    class="custom-select"></b-form-select>
                  {{ errors.first('level') }}
                  <b-form-invalid-feedback id="level-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col v-if="l1Options.length > 0" cols="3">
                <label for="Lv1">Lv1</label>
                <!-- Lv1  -->
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l1Options" v-model="mySchedule.l1"
                    class="custom-select" @change="handleChange(1)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- /Lv1  -->
              </b-col>
              <b-col v-if="l2Options.length > 0" cols="3">
                <label for="Lv2">Lv2</label>
                <!-- Lv2  -->
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l2Options" v-model="mySchedule.l2"
                    class="custom-select" @change="handleChange(2)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- /Lv2  -->
              </b-col>
              <b-col v-if="l3Options.length > 0" cols="3">
                <label for="Lv3">Lv3</label>
                <!-- Lv3  -->
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l3Options" v-model="mySchedule.l3"
                    class="custom-select" @change="handleChange(3)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- /Lv3  -->
              </b-col>
              <b-col v-if="l4Options.length > 0" cols="3">
                <label for="Lv4">Lv4</label>
                <!-- Lv4  -->
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l4Options" v-model="mySchedule.l4"
                    class="custom-select" @change="handleChange(4)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- Lv4  -->
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col v-if="l5Options.length > 0" cols="3">
                <label for="Lv5">Lv5</label>
                <!-- Lv5  -->
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l5Options" v-model="mySchedule.l5"
                    class="custom-select"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- Lv5  -->
              </b-col>
            </b-form-row>
          </div>
          <div class="form-wrap">
            <b-form-row>
              <b-col cols="6" class="mb-0">
                <label for="start-date">Start - Due Date</label>
                <div class="date-wrap">
                  <!-- start date -->
                  <b-form-group>
                    <b-input-group class="form-inline">
                      <b-form-input id="start-date" name="start-date" type="date" v-model="mySchedule.startDate"
                        v-validate="dateRule" class="custom-input" placeholder="YYYY-MM-DD"
                        :state="validateState('start-date')" aria-controls="start-date-input"
                        :max="mySchedule.dueDate"></b-form-input>
                      <b-form-invalid-feedback id="start-date-feedback">
                        {{ errors.first('start-date') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                  <!-- /start date -->
                  <span class="tilde">&#126;</span>
                  <!-- Due date -->
                  <b-form-group>
                    <b-input-group class="form-inline">
                      <b-form-input id="due-date" name="due-date" type="date" v-model="mySchedule.dueDate"
                        v-validate="dateRule" class="custom-input" data-vv-as="due date" placeholder="YYYY-MM-DD"
                        :state="validateState('due-date')" aria-controls="end-date-input"
                        :min="mySchedule.startDate"></b-form-input>
                      <b-form-invalid-feedback id="due-date-feedback">
                        {{ errors.first('due-date') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                  <!-- /Due date -->
                </div>
              </b-col>
              <div class="hour-wrap">
                <!-- estimatedHour -->
                <b-col class="mb-0">
                  <label for="estimatedHour">Est. Hours </label>
                  <b-input-group class="form-inline">
                    <b-form-input id="estimatedHour" type="text" name="estimatedHour" v-model="mySchedule.estHour"
                      maxlength="8" class="custom-input"></b-form-input>
                    <b-form-invalid-feedback id="estimatedHour-feedback">
                      {{ errors.first('estimatedHour') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-col>
                <!-- /estimatedHour -->
                <!-- Working Hour -->
                <b-col class="mb-0">
                  <label for="Work.Hours">Work Hours <span class="required"
                      v-if="mySchedule.status == 'DONE'">*</span></label>
                  <b-form-group>
                    <b-input-group class="form-inline">
                      <b-form-input id="workingHour" type="text" name="workingHour" v-model="mySchedule.workHour"
                        maxlength="8" ref="workingHour" v-validate="{ required: mySchedule.status == 'DONE' }"
                        :state="validateState('workingHour')" class="custom-input"></b-form-input>
                      <b-form-invalid-feedback id="workingHour-feedback">
                        {{ errors.first('workingHour') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- /Working Hour -->
              </div>
            </b-form-row>
          </div>
        </b-form>
      </div>
    </b-card>
    <div class="add-wrap">
      <b-card class="related">
        <!-- Related To -->
        <div class="card-header">
          <button type="button" class="btn-card-fold" :class="{ 'fold': isCardFold['relatedMySchedule'] }"
            @click="handleCardFold('relatedMySchedule')"></button>
          <!-- <label for="Related to">Related to</label> -->
          <div class="card-title-area">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M21 10.5L21 8.5C21 7.94772 20.5523 7.5 20 7.5L4 7.5C3.44772 7.5 3 7.94772 3 8.5L3 12.5C3 13.0523 3.44772 13.5 4 13.5L11 13.5"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14 16.5L20 16.5" stroke="#2E2E38" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M17 19.5L17 13.5" stroke="#2E2E38" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span class="title-text">Related My Schedule</span>
            <span v-if="mySchedule.relatedTo.length > 0" class="total-num">{{ mySchedule.relatedTo.length }}</span>
          </div>
        </div>
        <div class="card-body custom-scrollbar" :class="isCardFold['relatedMySchedule'] ? 'fold' : ''">
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-button @click="openModal('relatedToTable')" class="custom-input" variant="outline-secondary">
                  <div class="btn-inner">
                    <span>Search My Schedule</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M8.33333 14.1667C11.555 14.1667 14.1667 11.555 14.1667 8.33333C14.1667 5.11167 11.555 2.5 8.33333 2.5C5.11167 2.5 2.5 5.11167 2.5 8.33333C2.5 11.555 5.11167 14.1667 8.33333 14.1667Z"
                        stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12.5 12.5L17.5 17.5" stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </b-button>
                <modal :tableType="'relatedToTable'" ref="relatedToTable" :selectType="'multi'"
                  :selectedValues="mySchedule.relatedTo" :list="mySchedule.relatedTo" @set-result="setResult"></modal>
              </b-input-group>
            </b-form-group>
            <!-- Related list -->
            <b-form-group>
              <div class="tag-list">
                <template v-for="relatedTo in mySchedule.relatedTo">
                  <div :key="relatedTo.myScheduleId"
                    class="d-flex justify-content-between align-items-center related-my-schedule-tag">
                    <span class="span-90 custom-listTextstyle" @click="showOtherMyScheduleDetail(relatedTo.myScheduleId)"
                      style="cursor: pointer;" v-b-tooltip.hover :title="relatedTo.title">
                      <span class="related-id">
                        {{ relatedTo.myScheduleId }}
                      </span>
                      {{ relatedTo.title }}
                    </span>
                    <div class="badge-container">
                      <!-- variant 삭제 + 상태별로 별개 스타일 적용 위해 클래스 추가 함수 적용 -->
                      <b-badge class="btn" :class="getBadgeClass(relatedTo.status)">{{ relatedTo.status | formatStatus }}
                      </b-badge>
                      <b-badge variant="danger" class="btn btn-delete"
                        @click="removeObj(mySchedule.relatedTo, relatedTo)">Delete
                      </b-badge>
                    </div>
                  </div>
                </template>
              </div>
            </b-form-group>
            <!-- /Related list -->
          </b-col>
        </div>

        <!-- /Related To -->
      </b-card>
      <modal :tableType="'subordinateToTable'" ref="subordinateToTable" :selectType="'single'"
        :selectedValues="mySchedule.subordinateTo" :list="mySchedule.subordinateTo" @set-result="setResult"></modal>
    </div>
    <b-card class="description">
      <!-- Description -->
      <b-form-group>
        <!-- <label for="description">Description<span class="required">*</span></label> -->
        <editor :init="editorOption" api-key="dw48g1veahrvgrn78hzm6ixxmg18ye64at72wm8wsnbaddxn"
          v-model="mySchedule.description" ref="description" />
        <b-form-textarea v-show="false" rows="12" id="description" name="description" v-model="mySchedule.description"
          v-validate="{ required: true }" :state="validateState('description')"></b-form-textarea>
        <b-form-invalid-feedback id="description-feedback">
          {{ errors.first('description') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <!-- /Description -->
    </b-card>
    <b-card>
      <b-form-row class="align-items-end">
        <b-col cols="3" class="mb-0">
          <!-- File -->
          <b-form-group label="Add a file" label-for="file-input" class="new-file-label">
            <b-form-file multiple ref="file-input" id="file-input" name="file" v-model="fileInput"
              placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"
              class="new-file-input"></b-form-file>
          </b-form-group>
          <!-- /File -->
        </b-col>
        <!-- 신규 마크업 추가 - 파일 타입 -->
        <b-col cols="3" class="mb-0">
          <b-form-group>
            <label for="file-type-list">Type</label>
            <b-form-select id="file-type-list" name="type" size="sm" class="custom-select"></b-form-select>
          </b-form-group>
        </b-col>
        <!-- 신규 마크업 추가 - 파일 설명 -->
        <b-col class="mb-0 flex-grow">
          <b-form-group>
            <label for="file-description">Description</label>
            <b-input-group class="form-inline">
              <b-form-input id="file-description" type="text" name="file-description" class="custom-input"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- 신규 마크업 추가 - 파일 업로드 버튼 -->
        <div class="file-upload-btn-wrap">
          <b-button type="button" class="btn-secondary small">File Upload
          </b-button>
        </div>
      </b-form-row>
      <!-- File list -->
      <b-form-group v-if="showFiles()">
        <!-- <label>Files</label> -->
        <div class="file-list">
          <template v-for="file in mySchedule.files">
            <div v-if="!file.deleted" :key="file.filename" class="d-flex justify-content-between file-item">
              <span class="file-type-tag">Type</span>
              <div class="file-info-area">
                <span class="file-name">{{ file.attachedFilename }}</span>
                <!-- 신규 마크업 추가 - 파일 업로드 시간 -->
                <span class="file-upload-time">2023-07-21 11:46:03</span>
              </div>
              <!-- 신규 마크업 추가 - 파일 설명 영역 -->
              <div class="file-description">
                file description dummy text / 파일 설명 텍스트 영역
              </div>
              <div>
                <b-badge v-if="!file.new" class="btn mr-2 btn-file-download" variant="primary"
                  @click="downloadFile(file)">Download
                </b-badge>
                <b-badge variant="danger" class="btn btn-delete" @click="deleteFile(file)">Delete
                </b-badge>
              </div>
            </div>
          </template>
        </div>
      </b-form-group>
      <!-- /File list -->
      <!-- Image preview -->
      <b-form-group v-if="showImages()">
        <div class="image-preview-area border-top">
          <label>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M20 4.5H4C3.44772 4.5 3 4.94772 3 5.5V19.5C3 20.0523 3.44772 20.5 4 20.5H20C20.5523 20.5 21 20.0523 21 19.5V5.5C21 4.94772 20.5523 4.5 20 4.5Z"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M3 17.4997L8.22999 11.398C8.63274 10.9282 9.36128 10.9332 9.75746 11.4086L13.299 15.6585C13.6754 16.1102 14.3585 16.1412 14.7743 15.7254L16.21 14.2897C16.6314 13.8683 17.3256 13.9067 17.698 14.3721L21 18.4997"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M14 9.5C14 8.94772 14.4477 8.5 15 8.5C15.5523 8.5 16 8.94772 16 9.5C16 10.0523 15.5523 10.5 15 10.5C14.4477 10.5 14 10.0523 14 9.5Z"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Image Preview
          </label>
        </div>
        <div class="image-preview-list">
          <template v-for="(file, index) in mySchedule.files">
            <!-- b-card -> div로 교체 -->
            <div class="image-item" v-if="isImage(file)" :key="`${file.attachedFilename}-${index}`">
              <!-- <template #header>
                <span class="image-title">{{ file.attachedFilename }}</span>
              </template> -->
              <div>
                <img :src="file.url" class="image-box" />
              </div>
            </div>
          </template>
        </div>
      </b-form-group>
      <!-- /Image preview -->
    </b-card>
    <b-card class="comment">
      <!-- Posted Replies -->
      <div class="comment-area">
        <div class="comment-list-wrap">
          <div class="comment-title-area">
            <h3>Comment</h3>
            <span class="total-num">{{ replies.length }}</span>
          </div>
          <div class="comment-list">
            <div v-for="reply in replies" :key="reply.id" class="comment-item">
              <my-schedule-Reply ref="replyforms" :param=reply>
              </my-schedule-Reply>
            </div>
          </div>
        </div>
        <!-- New Reply Form-->
        <my-schedule-Reply :param=this.id ref="MyScheduleReply" @reload-replies="retrieveReplyList"
          class="comment-reply"></my-schedule-Reply>
        <!-- /New Reply Form -->
      </div>

      <!-- /Posted Replies -->
      <div class="highlight-area">
        <div class="comment-title-area">
          <h3>Highlight</h3>
          <span class="total-num">{{ replies.filter(reply => reply.highlight === true).length }}</span>
        </div>
        <div class="comment-list custom-scrollbar">
          <div v-for="reply in replies.filter(reply => reply.highlight === true)" :key="reply.id" class="comment-item">
            <my-schedule-Reply ref="replyforms" :param=reply>
            </my-schedule-Reply>
          </div>
        </div>
      </div>
    </b-card>
    <div class="my-schedule-btn-wrap" :class="{ 'bottom': isPageEnd }">
      <div class="btn-move-wrap">
        <b-button @click="showPrevMySchedule" :disabled="!prevMyScheduleId" type="button" class="btn-line prev">Prev
        </b-button>
        <b-button @click="showNextMySchedule" :disabled="!nextMyScheduleId" type="button" class="btn-line next">Next
        </b-button>
      </div>
      <div class="text-container">
        <span class="d-flex text">Created by {{ mySchedule.creatorId }} at {{
          mySchedule.creationDate
        }}</span>
        <span class="d-flex text" v-if="mySchedule.updaterId != null" style="text-align : right;">Updated by {{
          mySchedule.updaterId
        }} at {{ mySchedule.updatedDate }}</span>
      </div>
      <div class="button-container">
        <b-button @click="cancel" type="button" class="btn-secondary">Close
        </b-button>
        <b-button @click="createSubMySchedule" type="button" class="btn-sub-primary">Sub My Schedule
        </b-button>
        <b-button @click="createRelatedMySchedule" type="button" class="btn-sub-primary">Related My Schedule
        </b-button>
        <b-button @click="update" variant="primary" class="btn-primary">Update
        </b-button>
      </div>
      <!-- /Buttons -->
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import MyScheduleReply from './MyScheduleReply.vue';
import modal from '@/components/chatter/MyScheduleModal.vue';
import { VueEditor } from 'vue2-editor';
import Editor from '@tinymce/tinymce-vue';
import vClickOutside from 'v-click-outside';

export default {
  props: { id: { type: String, default: "-1" } },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { Loading, MyScheduleReply, modal, Editor },
  data() {
    return {
      isRelationCoallapseVisible: true,
      replies: [],
      loading: false,
      myScheduleId: '',
      serial: 0,
      blReplyVal: false,
      mySchedule: {
        title: '',
        status: 'TO_DO',
        assignee: '',
        level: '',
        priority: '',
        type: '',
        job: '',
        estHour: '',
        workHour: '',
        subordinateTo: [],
        superiorTo: [],
        relatedTo: [],
        dueDate: '',
        startDate: '',
        description: '',
        files: [],
        l1: '',
        l2: '',
        l3: '',
        l4: '',
        l5: '',
        updatedDate: '',
        updaterId: '',
        creatorId: '',
        creationdDate: '',
      },
      showDropdown: { 'project': false },
      notForShowValues: [],
      fileInput: [],
      dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
      originData: null,
      methodologyOptions: [],
      blContentModified: null,
      editorOption: {
        menubar: "file edit view insert format tools table help",
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
          'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        paste_data_images: true,
        image_advtab: true,
        statusbar: false,
        contextmenu: false,
      },
      // mySchedule-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      isPageEnd: false,
      // 스크롤 시 my-schedule-top-area의 title 노출 이벤트 위해 추가
      isScrollStart: false,
      // card 영역 접히고 펼치는 이벤트 위해 추가
      isCardFold:
      {
        title: false,
        relatedMySchedule: false
      },
    };
  },
  watch: {
    '$route': {
      handler(newRoute, oldRoute) {
        this.showOtherMyScheduleDetail(this.id);
      },
      immediate: false // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
    },
    'mySchedule.dueDate': {
      handler(newVal, oldVal) {
        // Initialize 시 예외
        if (this.originData.dueDate == null || this.originData.dueDate == "") {
          return;
        }
        if (this.originData.dueDate != "" && this.mySchedule.dueDate == this.originData.dueDate) {
          return;
        }
        // Duedate가 변경시 Reply Validation 추가
        this.$emit("reply-validation", "", (this.originMySchedule.dueDate != this.mySchedule.dueDate));
      }
    },
    'mySchedule.status': {
      handler(newVal) {
        // 프로젝트 ID 변경 시
        this.blReplyVal = (newVal === 'DONE' || newVal === 'CANCELLED')
        this.$refs.MyScheduleReply.setValidation(this.blReplyVal);
      }
    },
    'isCardFold.relatedMySchedule': {
      handler() {
        this.isCardFold['watcher'] = this.isCardFold['relatedMySchedule']
      }
    },
    fileInput() {
      if (!this.fileInput || this.fileInput.length === 0) return;
      this.fileInput.forEach(async file => {
        const clone = new File([file], file.name, { type: file.type, });
        let fileInfo = {
          attachedFileId: '',
          attachedFilename: file.name,
          attachedFilePath: '',
          type: file.type,
          file: clone,
          new: true,
          deleted: false,
          url: '',
        };
        fileInfo.url = this.isImage(fileInfo) ? await this.createFileURL(fileInfo) : null
        this.mySchedule.files.push(fileInfo);
      });
      this.$refs['file-input'].reset();
    },
    mySchedule: {
      deep: true,
      handler() {
        if (this.blContentModified != null) {
          this.blContentModified = true;
        } else {
          this.blContentModified = false;
          for (var i = 1; i < 5; i++) {

            if (this.mySchedule["l" + i] === '') {
              let idx = i + 1;
              this.mySchedule["l" + idx] = '';
            }
          }
        }
      },
    }
  },
  computed: {
    mySchedules() {
      return this.$store.getters['mySchedule/mySchedules'];
    },
    currMyScheduleIdx() {
      return this.mySchedules.findIndex(mySchedule => mySchedule.myScheduleId === this.id);
    },
    prevMyScheduleIdx() {
      if (this.currMyScheduleIdx === -1) return null;
      const idx = this.currMyScheduleIdx - 1;
      return idx < 0 ? null : idx;
    },
    nextMyScheduleIdx() {
      if (this.currMyScheduleIdx === -1) return null;
      const idx = this.currMyScheduleIdx + 1;
      return idx >= this.mySchedules.length ? null : idx;
    },
    prevMyScheduleId() {
      const prevMySchedule = this.mySchedules[this.prevMyScheduleIdx];
      return prevMySchedule ? prevMySchedule.myScheduleId : null
    },
    nextMyScheduleId() {
      const nextMySchedule = this.mySchedules[this.nextMyScheduleIdx];
      return nextMySchedule ? nextMySchedule.myScheduleId : null
    },
    /*
    selectedProjectOption() {
      return this.projectOptions.find(option => option.value === this.mySchedule.projectId);
    },*/
    filter() {
      return this.$store.getters['mySchedule/filter'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'].caller;
    },
    statusOptions() {
      return this.$store.getters['mySchedule/statusOptions']
        .filter(status => status.value)
        .filter(status => status.update)
        .map(status => ({ ...status, text: status.text.replaceAll("\u00A0", '') }));
    },
    /*
    projectOptions() {
      return this.$store.getters['mySchedule/projectOptions']
        .filter(status => status.value);
    },*/
    priorityOptions() {
      return this.$store.getters['mySchedule/priorityOptions']
    },
    levelOptions() {
      return this.$store.getters['mySchedule/levelOptions']
    },
    typeOptions() {
      return this.$store.getters['mySchedule/typeOptions']
    },
    jobOptions() {
      return this.$store.getters['mySchedule/jobOptions']
    },
    l1Options() {
      return this.getOptions(1);
    },
    l2Options() {
      return this.getOptions(2);
    },
    l3Options() {
      return this.getOptions(3);
    },
    l4Options() {
      return this.getOptions(4);
    },
    l5Options() {
      return this.getOptions(5);
    }
  },
  // vue.js LifeCycle Hook Event 발생 시점 : 컴포넌트가 생성 되는 시점
  created() {
    this.loadMySchedule();
    document.addEventListener('keydown', this.handleKeyDown);
  },
  mounted() {
    // mySchedule-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.addEventListener('scroll', this.handleScroll)
    // 스크롤 시 my-schedule-top-area의 title 노출 이벤트 위해 추가
    window.addEventListener('scroll', this.showTitle)
  },
  // vue.js LifeCycle Hook Event 발생 시점 : 생성된 컴포넌트가 폐기 되는 시점
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

    // mySchedule-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.removeEventListener('scroll', this.handleScroll);
    // 스크롤 시 my-schedule-top-area의 title 노출 이벤트 위해 추가
    window.removeEventListener('scroll', this.showTitle)
  },
  methods: {
    handleChange(param) {
      if (param) {
        for (var i = param; i < 5; i++) {
          let idx = i + 1;
          this.mySchedule["l" + idx] = '';
        }
      }
    },
    /*
    checkObjectProperty(id, property) {
      let index = this.projectOptions.findIndex(obj => obj[property] === id);
      return this.projectOptions[index]['projectType'];
    },
    */
    async retrieveMethodologyOptions(projectType) {
      let response = await axios.get("chatter/retrieveDevMethodologyOptionList/" + projectType, {
        params: {},
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      });
      this.methodologyOptions = response.data.map(item => {
        return {
          text: item.code,
          value: item.code,
          level: item.level,
          parent: item.parent,
        };
      });
    },
    getOptions(lv) {
      let numericLv = null;
      if (typeof (lv) == String) {
        const regex = /\d+/g;
        const matches = lv.match(regex);
        numericLv = parseInt(matches[0]);
      } else {
        numericLv = lv;
      }
      let options = [];
      if (numericLv == 1) {
        options = this.methodologyOptions.filter(item => item.level === numericLv)
      } else {
        numericLv = numericLv - 1;
        options = this.methodologyOptions.filter(item => item.parent === this.mySchedule['l' + numericLv]);
      }
      return options;
    },
    setStatus(status) {
      this.mySchedule.status = status;
    },
    openModal(ref) {
      this.$refs[ref].openModal(ref);
    },
    showMyScheduleDetail(myScheduleId) {
      this.myScheduleId = myScheduleId
      this.loadMySchedule();
    },
    removeTag(tag) {
      const index = this.mySchedule.watchers.findIndex(watcher => watcher === tag);
      if (index !== -1) {
        this.mySchedule.watchers.splice(index, 1);
      }
    },
    removeObj(list, key) {
      let index = -1;
      if (typeof (list) == 'string') {
        list = this.mySchedule[list];
        list.forEach((item, i) => {
          if (item.myScheduleId == key) {
            index = i;
          }
        });
      } else {
        index = list.findIndex(obj => obj === key)
      }
      if (index !== -1) {
        list.splice(index, 1);
      }
    },
    setResult(selectedResult, list) {
      list.splice(0, list.length, ...selectedResult);
    },
    isImage(file) {
      return !file.deleted && file.type && file.type.includes('image')
    },
    showFiles() {
      return this.mySchedule.files && this.mySchedule.files.length > 0 &&
        this.mySchedule.files.some(file => !file.deleted);
    },
    showImages() {
      return this.mySchedule.files && this.mySchedule.files.length > 0 &&
        this.mySchedule.files.some(file => this.isImage(file));
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async update() {
      if (!this.blContentModified) {
        this.$refs.MyScheduleReply.setValidation(true);
      } else {
        await this.$validator.validate();
      }
      await this.$refs.MyScheduleReply.$validator.validate();

      try {
        if (this.errors && this.errors.items.length > 0) {
          const errorItems = this.errors.items;
          const errorItemsLength = errorItems.length;
          for (let i = 0; i < errorItemsLength; i++) {
            const error = errorItems[i];
            this.$bvToast.toast(error.msg, {
              title: `Notification`,
              toaster: "b-toaster-bottom-center",
              solid: true,
              appendToast: false,
              autoHideDelay: 400,
              variant: "danger"
            });
            if (this.$refs[error.field]) {
              this.$nextTick(() => {
                this.$refs[error.field].focus();
              });
            }
            break;
          }
          return Promise.reject(new Error('400'));
        } else {
          if (this.blContentModified) {
            await this.updateDetail();
          }
          await this.$refs.MyScheduleReply.replyPost();
          this.$bvToast.toast(`My Schedule이 업데이트 되었습니다.`, {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 400
          })
        }
      } catch (error) {
        this.showError(error.message);
      }

    },
    async updateDetail() {
      // Create formData
      let data = new FormData();
      data.append('title', this.mySchedule.title);
      data.append('status', this.mySchedule.status);
      data.append('assignee', this.mySchedule.assignee);
      data.append('level', this.mySchedule.level);
      data.append('priority', this.mySchedule.priority);
      data.append('type', this.mySchedule.type);
      data.append('job', this.mySchedule.job);
      data.append('estHour', this.mySchedule.estHour);
      data.append('workHour', this.mySchedule.workHour);
      data.append('startDate', this.mySchedule.startDate);
      data.append('l1', this.mySchedule.l1);
      data.append('l2', this.mySchedule.l2);
      data.append('l3', this.mySchedule.l3);
      data.append('l4', this.mySchedule.l4);
      data.append('l5', this.mySchedule.l5);
      let paramSubordinateTo = []
      if (this.mySchedule.subordinateTo[0] != null) {
        paramSubordinateTo = this.mySchedule.subordinateTo[0].myScheduleId;
      } else {
        paramSubordinateTo = []
      }
      data.append('subordinateTo', paramSubordinateTo);
      let paramRelatedTo = [];
      this.mySchedule.relatedTo.forEach(relatedTo => paramRelatedTo.push(relatedTo.myScheduleId));
      data.append('relatedTo', paramRelatedTo);
      data.append('dueDate', this.mySchedule.dueDate);
      data.append('description', this.mySchedule.description);

      this.mySchedule.files.forEach(file => {
        if (file.new && !file.deleted) {
          data.append('files', file.file);
        }
      });
      // Update the mySchedule
      await axios.post('chatter/updateMySchedule/' + this.mySchedule.myScheduleId,
        data,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            Authorization: accessToken()
          }
        });
      // Delete files
      data = new FormData();
      let fileIds = [];
      this.mySchedule.files.forEach(file => {
        if (!file.new && file.deleted) {
          fileIds.push(file.attachedFileId);
        }
      });
      data.append('fileIds', fileIds);

      if (fileIds.length > 0) {
        await axios.post('chatter/deleteMyScheduleFile', data, {
          headers: {
            Authorization: accessToken()
          }
        });
      }
    },
    deleteFile(file) {
      file.deleted = true;
    },
    async createFileURL(file) {
      try {
        let data = null;
        if (file.new && file.file) {
          data = file.file;
          return null;
        } else if (!file.new && file.attachedFilePath) {
          let response = await axios.get('chatter/image/' + file.attachedFileId, {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          });
          data = response.data;
        }
        return data ? URL.createObjectURL(data) : null;
      } catch (error) {
        await this.showError(error);
      }
    },
    createSubMySchedule() {
      this.pushRoute({ name: "myScheduleNew", params: { parentMySchedule: this.mySchedule } });
    },
    createRelatedMySchedule() {
      this.pushRoute({ name: "myScheduleNew", params: { siblingMySchedule: this.mySchedule } });
    },
    handleKeyDown(event) {
      // Ctrl+S (또는 Command+S)를 누른 경우에만 myMethod 호출
      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault(); // 기본 동작(페이지 저장) 방지
        this.update();
      }
    },
    getTextOfOptions(status) {
      // statusOptions 배열에서 status 값과 value가 같은 객체 찾기
      const matchedOption = this.statusOptions.find(option => option.value === status);
      // 찾은 객체가 있으면 해당 객체의 text 값을 반환하고, 없으면 빈 문자열 반환
      return matchedOption ? matchedOption.text : '';
    },
    showPrevMySchedule() {
      if (this.prevMyScheduleId) {
        this.pushRoute('/chatter/my-schedule' + this.prevMyScheduleId);
      }
    },
    showNextMySchedule() {
      if (this.nextMyScheduleId) {
        this.pushRoute('/chatter/my-schedule' + this.nextMyScheduleId);
      }
    },
    showOtherMyScheduleDetail(myScheduleId) {
      this.pushRoute({ name: "myScheduleDetail", params: { id: myScheduleId } });
      this.loadMySchedule();
      this.$refs.MyScheduleReply.$forceUpdate();
    },
    toast(toaster, append = false) {
      this.counter++
      this.$bvToast.toast(`Toast ${this.counter} body content`, {
        title: ``,
        toaster: toaster,
        solid: true,
        appendToast: append
      })
    },
    async validate() {
      let errFields = [];
      this.errors.items.forEach((error) => {
        errFields.push(error.field);
      });
      return errFields;
    },
    async setReplyValidation(blVal) {
      this.blReplyVal = blVal;
    },
    cancel() {
      this.pushRoute('/chatter/my-schedule');
    },
    async loadMySchedule() {
      try {
        this.loading = true;
        /*
        await Promise.all([
          this.$store.dispatch('mySchedule/retrieveProjectOptions'),
          this.$store.dispatch('mySchedule/retrieveAssigneeOptions')
        ])*/

        this.retrieveMyScheduleDetail();
        this.retrieveReplyList();
      } catch (error) {
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async retrieveMyScheduleDetail() {
      // Load mySchedule
      let response = await axios.post('/chatter/retrieveMySchedule/' + this.id, {}, {
        headers: {
          Authorization: accessToken()
        }
      });
      let data = response.data;
      this.originData = { ...response.data };
      // Set file information
      if (!data.files) {
        data.files = [];
      }

      // add new fields
      await Promise.all(data.files.map(async file => {
        file.new = file.deleted = false;
        file.url = this.isImage(file) ? await this.createFileURL(file) : '';
      }));

      // Set mySchedule to the data
      if (response.data.subordinateTo != null) {
        response.data.subordinateTo = [response.data.subordinateTo];
      } else {
        response.data.subordinateTo = [];
      }
      this.mySchedule = response.data;
      this.originMySchedule = JSON.parse(JSON.stringify(this.mySchedule));
      if (!this.notForShowValues.includes(this.mySchedule.creatorId)) {
        this.notForShowValues.push(this.mySchedule.creatorId);
      }

    },
    async retrieveReplyList(myScheduleId) {
      let myScheduleIdx = this.id;
      if (myScheduleId) {
        myScheduleIdx = myScheduleId;
      }
      try {
        this.loading = true;
        let response = await axios.get('/chatter/retrieveMyScheduleCommentList/' + myScheduleIdx, {
          headers: {
            Authorization: accessToken()
          }
        });
        this.replies = response.data;
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadFile(file) {
      try {
        this.loading = true;
        await this.download(file);
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async download(file) {
      const link = document.createElement('a');
      let url = await this.createFileURL(file);
      if (url) {
        link.href = url;
        link.download = file.attachedFilename;
        link.click();
      }
    },
    // mySchedule-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    handleScroll() {
      const scrollPosition = document.documentElement.scrollTop;
      if ((scrollPosition + window.innerHeight) >= document.body.scrollHeight) {
        this.isPageEnd = true;
      } else {
        this.isPageEnd = false;
      }
    },
    // related mySchedule 배지 클래스 추가
    getBadgeClass(status) {
      if (status == ' In Progress') return 'in-progress'
      else if (status == ' To Do') return 'to-do'
      else if (status == ' Done') return 'done'
      else if (status == ' Closed') return 'closed'
      else if (status == ' Cancelled') return 'cancelled'
    },
    // 스크롤 시 my-schedule-top-area의 title 노출 이벤트 위해 추가
    showTitle() {
      const scrollPosition = document.documentElement.scrollTop;
      const myScheduleTopAreaPosY = document.querySelector('.my-schedule-top-area').getBoundingClientRect().top;
      if (scrollPosition >= myScheduleTopAreaPosY) {
        this.isScrollStart = true;
      } else {
        this.isScrollStart = false;
      }
    },
    // 상단의 dropdown-menu 의 상태에 따라 컬러 변경을 위해 클래스 추가
    getStatusClass(status) {
      if (status == 'IN_PROGRESS') return 'in-progress'
      else if (status == 'TO_DO') return 'to-do'
      else if (status == 'DONE') return 'done'
      else if (status == 'CLOSED') return 'closed'
      else if (status == 'CANCELLED') return 'cancelled'
    },
    handleCardFold(ref) {
      this.isCardFold[ref] = !this.isCardFold[ref];
    },
    toggleDropdown(target) {
      this.showDropdown[target] = !this.showDropdown[target];
    },
    selectOption(option, target) {
      //this.mySchedule.projectId = option.value;
      this.showDropdown[target] = false;
    },
    closeOptions() {
      for (const key in this.showDropdown) {
        if (this.showDropdown.hasOwnProperty(key)) {
          this.showDropdown[key] = false;
        }
      }
    },
  },
  filters: {
    formatStatus(strStatus) {
      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
  },
}
</script>
<style>
.text-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  text-overflow: ellipsis;
  /* 초과된 텍스트를 "..."으로 표기 */
}

.button-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  margin: 0.2em;
  padding: 0.2em;
}

.card .card-body {
  margin-top: 0em;
  padding-top: 0%;
  padding-bottom: 1%;
}

.card .card-header {
  padding-left: 0;
  background-color: white !important;
}

span.required {
  color: red;
}

.image-title {
  display: block;
  margin-bottom: .3rem;
}

.image-box {
  display: block;
  max-width: 100%;
}

.hide-toolbar .ql-toolbar {
  display: none;
}

.hide-border .ql-container {
  border: none !important;
}

.custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

.custom-tags {
  height: 1.1rem !important;
}

.span-90 {
  width: 85%;
}

.badge-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 20%;
}

.badge-container .btn {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.custom-listTextstyle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.b-form-tags .badge {
  display: inline-flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  line-height: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  height: 2em;
}

div[contenteditable="true"]:focus {
  outline: none;
}

.col-label {
  display: flex;
  justify-content: flex-end;
}

.tox-tinymce {
  border-radius: 0.6rem !important;
  min-height: 35rem !important;
}

.tox .tox-statusbar {
  display: none;
}

/* 신규 추가 스타일 */
.btn-select-status .dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0 0.933rem;
  height: 100%;
  padding: 0.266rem 1.066rem 0.266rem 1.6rem;
  border: none;
  border-radius: 38px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}

.btn-select-status.in-progress .dropdown-toggle,
.btn-select-status.in-progress .dropdown-toggle.show,
.btn-select-status.in-progress.show .dropdown-toggle,
.btn-select-status.in-progress .dropdown-toggle:hover {
  background-color: #FF5C00;
}

.btn-select-status.to-do .dropdown-toggle,
.btn-select-status.to-do .dropdown-toggle.show,
.btn-select-status.to-do.show .dropdown-toggle,
.btn-select-status.to-do .dropdown-toggle:hover {
  background-color: #747480;
}

.btn-select-status.done .dropdown-toggle,
.btn-select-status.done .dropdown-toggle.show,
.btn-select-status.done.show .dropdown-toggle,
.btn-select-status.done .dropdown-toggle:hover {
  background-color: #1755CC;
}

.btn-select-status.closed .dropdown-toggle,
.btn-select-status.closed .dropdown-toggle.show,
.btn-select-status.closed.show .dropdown-toggle,
.btn-select-status.closed .dropdown-toggle:hover {
  background-color: #168D4C;
}

.btn-select-status.cancelled .dropdown-toggle,
.btn-select-status.cancelled .dropdown-toggle.show,
.btn-select-status.cancelled.show .dropdown-toggle,
.btn-select-status.cancelled .dropdown-toggle:hover {
  background-color: #E4E4EA;
  color: #747480;
}

.btn-select-status .dropdown-toggle::after {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 0;
  content: "";
  border: none;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.832 7.5L9.9987 13.3333L4.16536 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.card.description .tox-tinymce {
  border: none !important;
}

.b-form-tag>button.b-form-tag-remove {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  opacity: 1;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.new-file-label label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.new-file-input .custom-file-input {
  height: 100%;
}

.new-file-input .custom-file-input~.custom-file-label[data-browse]::after {
  content: none;
}

.new-file-input .custom-file-input.focus {
  border: none;
  box-shadow: none;
}

.new-file-input .custom-file-label {
  height: 100%;
  padding: 0.533rem 1.066rem;
  margin-bottom: 0;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
}

.new-file-input .custom-file-label span {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

/* comment 영역 */
.card.comment {
  position: relative;
}

.card.comment .card {
  margin-bottom: 0;
  border-radius: 0 0 0 30px;
  box-shadow: none;
}

.card.comment .card-body {
  padding: 0;
}

.card.comment .card-body .form-group {
  margin: 0;
}

.card.comment .card.comment-reply .ql-toolbar.ql-snow {
  border-top: 1px solid #DDDDE3;
  border-bottom: 1px solid #DDDDE3;
  border-left: none;
  border-right: none;
}

.card.comment .card.comment-reply .ql-container.ql-snow {
  border: none;
}

/* related mySchedule, subordinate mySchedule 팝업 */
#relatedToTable.modal.show .modal-dialog,
#subordinateToTable.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#relatedToTable .modal-content,
#subordinateToTable .modal-content {
  border-radius: 20px;
}

#relatedToTable .modal-header,
#subordinateToTable .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

#relatedToTable .modal-header h5,
#subordinateToTable .modal-header h5 {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

#relatedToTable .modal-body,
#subordinateToTable .modal-body {
  padding: 1.041vw 1.6rem 1.041vw 2.666rem;
}

#relatedToTable .modal-footer,
#subordinateToTable .modal-footer {
  justify-content: center;
  gap: 0 0.666rem;
  padding: 1.562vw 2.666rem 2.604vw;
  border-top: 0px;
  border-radius: 0 0 20px 20px;
}

#relatedToTable .btn,
#subordinateToTable .btn {
  margin: 0;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#relatedToTable .btn-primary,
#subordinateToTable .btn-primary {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#relatedToTable .btn-primary:hover,
#subordinateToTable .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#relatedToTable .btn-primary.disabled,
#relatedToTable .btn-primary:disabled,
#subordinateToTable .btn-primary.disabled,
#subordinateToTable .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#relatedToTable .modal-footer .btn-secondary,
#subordinateToTable .modal-footer .btn-secondary {
  width: 148px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: #747480;
  color: #fff;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#relatedToTable .modal-footer .btn-secondary:hover,
#subordinateToTable .modal-footer .btn-secondary:hover {
  background-color: #565662;
}

#relatedToTable .modal-footer .btn-secondary.disabled,
#relatedToTable .modal-footer .btn-secondary:disabled,
#subordinateToTable .modal-footer .btn-secondary.disabled,
#subordinateToTable .modal-footer .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-secondary {
  width: 148px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.btn-secondary.small {
  height: 40px;
}

.btn-secondary:hover {
  background-color: #565662;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-sub-primary {
  width: 160px;
  height: 60px;
  background-color: #2E2E38;
  border: none;
  color: #FFF;
}

.btn-sub-primary:hover {
  background-color: #0D0D17;
}

.btn-sub-primary.disabled,
.btn-sub-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-line {
  position: relative;
  width: 100px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn-line.disabled,
.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn-line.small {
  height: 40px;
}

.btn-line.prev {
  padding: 0 1.866rem 0 2.866rem;
}

.btn-line.prev::before {
  content: '';
  display: block;
  position: absolute;
  left: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.prev.disabled::before,
.btn-line.prev:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.next {
  padding: 0 2.866rem 0 1.866rem;
}

.btn-line.next::before {
  content: '';
  display: block;
  position: absolute;
  right: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.next.disabled::before,
.btn-line.next:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-delete,
.badge-container .btn-delete {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
}

.btn-card-fold {
  position: absolute;
  top: 2rem;
  right: 2.666rem;
  display: block;
  width: 30px;
  height: 30px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 18.75L15 10L6.25 18.75" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  border: none;
  z-index: 100;
}

.btn-card-fold.fold {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 11.25L15 20L6.25 11.25" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.btn-file-download {
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  border: 1px solid #C4C4CD;
  background-color: #FFF;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin-top: 1.333rem;
}

.btn-file-download:hover {
  border: 1px solid #747480;
}

/* 공통요소 */
span.required {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #FF0000;
  border-radius: 50%;
  font-size: 0;
}

.border-bottom {
  border-bottom: 1px solid #DDDDE3;
}

.border-top {
  border-top: 1px solid #DDDDE3;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.flex-grow {
  flex-grow: 1;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 20px;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #F6F6FA;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* select */
.custom-select {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-select.is-valid {
  border: 1px solid #00A438;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-invalid {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-valid:focus {
  box-shadow: none;
  border: 1px solid #00A438;
}

.custom-select.is-invalid:focus {
  box-shadow: none;
  border: 1px solid #FF0000;
}

.custom-select#project-list {
  padding: 0.266rem 0.8rem 0.266rem 1.2rem;
  border-radius: 38px;
  background-color: #E4E4EA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 7px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

/* custom select */
.custom-select-area {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
  margin-bottom: 1.5625vw;
}

.custom-select-box {
  position: relative;
  width: fit-content;
  min-width: 180px;
  text-align: left;
  cursor: default;
  font-family: 'NanumGothic';
}

.custom-select-box .select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  width: 100%;
  height: 35px;
  padding-left: 1.2rem;
  padding-right: 0.8rem;
  border-radius: 38px;
  border: 1px solid transparent;
  background-color: #E4E4EA;
}

.custom-select-box .select .text {
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: #747480;
  line-height: 1.8;
  appearance: none;
}

.custom-select-box .select .icon-arrow {
  display: block;
  width: 20px;
  height: 21px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8333 8L9.99992 13.8333L4.16659 8" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.custom-select-box .select .text::after {
  content: '';
  display: block;
  position: absolute;
  top: 8px;
  right: -6px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #FF0000;
}

.custom-select-box.active .select {
  background-color: #fff;
  border-color: #000;
}

.custom-select-box.active .select .text {
  color: #2E2E38;
}

.custom-select-box.active .select .text::after {
  content: none;
}

.custom-select-box.active .select .icon-arrow {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.custom-select-box .opt-list {
  display: none;
  position: absolute;
  top: 3.066rem;
  left: 0;
  z-index: 150;
  width: 100%;
  max-height: 200px;
  padding: 0.4rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  list-style: none;
  overflow-y: auto;
}

.custom-select-box .opt-list .opt-inner {
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  background-color: #F6F6FA;
  color: #747480;
  font-size: 12px;
  font-weight: 500;
}

.custom-select-box.active .opt-list {
  display: block;
}

.custom-select-box .opt-item:hover .opt-inner {
  background-color: #E7E7EE;
  color: #2E2E38;
  font-weight: 700;
}

/* input */
.form-group {
  margin-bottom: 0;
}

.title-wrap .form-group {
  margin-bottom: 0;
}

label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.custom-input,
input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-input.small {
  width: min(15.866rem, 12.395vw);
}

.form-control#title {
  padding-left: 1px;
  background-color: transparent;
  font-family: 'NanumGothic';
  font-weight: 700;
}

.form-control#title::placeholder {
  font-size: 30px;
}

.form-control:focus {
  box-shadow: none;
  border-color: unset;
}

.form-control.is-valid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>');
}

.form-control.is-invalid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>');
}

.form-control.is-valid:focus {
  box-shadow: 0 0 0 1px #00A438;
}

.form-control.is-invalid:focus {
  box-shadow: 0 0 0 1px #FF0000;
}

.input-group:not(.has-validation)>.form-control:not(:last-child) {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-file {
  height: 2.666rem;
}

/* form */
.form-wrap {
  padding: 2.0833vw 0 0.5208vw;
}

.form-wrap:last-child {
  padding: 2.0833vw 0 0;
}

.form-row {
  margin-left: -0.7812vw;
  margin-right: -0.7812vw;
}

.form-row>.col,
.form-row>[class*="col-"] {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
  margin-bottom: 1.5625vw;
}

.invalid-feedback {
  position: absolute;
  margin-top: 2px;
  padding-left: 6px;
  color: #FF0000;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card .card-header {
  padding: 0;
  border-bottom: none;
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: max(2.666rem, 2.0833vw);
}

.card .card-body .card-body {
  padding: 0;
}

.card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

.card.description .card-body {
  padding: 0.666rem 0.666rem 1.666rem;
}

.card .title-wrap {
  margin-top: -0.666rem;
}

/* 상단 상태 + add a subordinate to mySchedule 영역 */
.my-schedule-top-area {
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.333rem;
  margin-top: -1.333rem;
  margin-bottom: 1.8rem;
  z-index: 100;
}

.full .my-schedule-top-area.sticky {
  top: 1.866rem;
  padding-left: 2rem;
}

.my-schedule-top-area .my-schedule-sub-area {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
}

.my-schedule-top-area .form-row {
  margin-left: 0;
}

.btn-add-my-schedule {
  height: auto !important;
  padding: 0.266rem 1.6rem 0.266rem 0.8rem;
  border-radius: 60px;
  background-color: #2E2E38;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  border: none;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 42px !important;
}

.btn-add-my-schedule:hover {
  background-color: #212529;
  border-color: unset;
}

.btn-add-my-schedule:active {
  background-color: #212529;
  border-color: unset;
}

.btn-add-my-schedule .b-icon {
  width: 20px;
  height: 20px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 10H15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 15L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  font-size: 0;
}

.subordinate-item {
  gap: 0 1.333rem;
  max-width: 34.666rem;
  padding: 0.6rem 1.066rem 0.6rem 1.333rem;
  border-radius: 30px;
  background-color: #DDDDE3;
}

.subordinate-item .custom-listTextstyle {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

.subordinate-item .subordinate-id {
  position: relative;
  padding-right: 0.8rem;
  margin-right: 0.8rem;
}

.subordinate-item .subordinate-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 3px;
  width: 1px;
  height: 14px;
  background-color: #747480;
}

.subordinate-item .badge-container {
  width: auto;
  gap: 0 2rem;
}

.subordinate-item .badge-container .btn.status-tag {
  width: auto;
  padding: 0.266rem 0.933rem;
  border-radius: 38px;
  background-color: #FFF;
  color: #168D4C;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.my-schedule-top-area .title-area {
  max-width: 35%;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.superior-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.8rem;
  /* padding-bottom: 1.333rem; */
}

.superior-item {
  gap: 0 1.333rem;
  max-width: 28.466rem;
  padding: 0.266rem 0.266rem 0.266rem 1.2rem;
  border-radius: 30px;
  border: 1px solid #DDDDE3;
  background-color: #FFF;
}

.superior-item:hover {
  border-color: #2E2E38;
}

.superior-item .superior-id {
  position: relative;
  padding-right: 0.8rem;
  margin-right: 0.8rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.superior-item .superior-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 3px;
  width: 1px;
  height: 12px;
  background-color: #C4C4CD;
}

.superior-item .badge-container .btn.status-tag {
  background-color: #E7E7EE;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
}

.my-schedule-id {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

/* 날짜 영역 / work hour 영역 */
.date-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
}

.date-wrap .tilde {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.hour-wrap {
  display: flex;
}

.hour-wrap .col {
  padding-right: 0.7812vw;
  padding-left: 0.7812vw;
}

/* add watcher + related my-schedule 영역 */
.add-wrap {
  display: flex;
  gap: 0 2rem;
}

.add-wrap .card>.card-body {
  padding: 0;
}

.add-wrap .card .card-body .card-header {
  padding: 2rem 2.0833vw;
  border-radius: 30px 30px 0 0;
}

.add-wrap .card .card-body .card-body {
  padding: 0 2.0833vw;
  margin-bottom: 0.4rem;
  max-height: 15.333rem;
  min-height: 15.333rem;
  overflow-y: auto;
}

.add-wrap .card.watcher {
  width: 36.857%;
  overflow: hidden;
}

.add-wrap .card.related {
  width: 100%;
  overflow: hidden;
}

.add-wrap .col {
  padding: 0;
}

.add-wrap .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

.add-wrap .card-title-area .icon {
  display: block;
  width: 24px;
  height: 24px;
}

.add-wrap .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

.add-wrap .card-title-area .total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #FFE500;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}

.add-wrap .input-group .btn {
  width: 100%;
  min-height: 40px;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background: #F6F6FA;
  color: #AAA;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.add-wrap .input-group .btn.btn-outline-secondary:focus {
  box-shadow: none;
}

.add-wrap .input-group .btn .btn-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-wrap .tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.666rem;
  margin-top: 1.333rem;
}

.add-wrap .b-form-tags .badge {
  gap: 0 0.55rem;
  height: 2.666rem;
  padding: 0.533rem 1rem 0.533rem 0.533rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  border-radius: 40px;
  background: #EDF1FF;
}

.add-wrap .b-form-tags .badge:hover {
  background-color: #DAE2FF;
}

.add-wrap .b-form-tags .badge .profile-img {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 0.8rem;
  border-radius: 50%;
  overflow: hidden;
}

.related-my-schedule-tag {
  gap: 0 0.666rem;
  align-items: center;
  max-width: 100%;
  padding: 0.533rem 1rem;
  border-radius: 40px;
  background: #FFF1ED;
  width: 70%;

}

.related-my-schedule-tag:hover {
  background-color: #FFD8CC;
}

.custom-listTextstyle {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.related-id {
  position: relative;
  padding-right: 0.666rem;
  margin-right: 0.666rem;
  font-weight: 700;
}

.related-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 2px;
  width: 1px;
  height: 14px;
  background-color: #747480;
}

.badge-container {
  justify-content: space-between;
  gap: 0 0.933rem;
  width: auto;
}

.badge-container:hover {
  border-color: #2E2E38;
}

.badge-container .btn {
  width: auto;
  padding: 0.266rem 0.666rem;
  overflow: initial;
  text-overflow: unset;
  border-radius: 60px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
}

.badge-container .badge.in-progress {
  background-color: #FF5C00;
}

.badge-container .badge.to-do {
  background-color: #747480;
}

.badge-container .badge.cancelled {
  background-color: #E4E4EA;
  color: #747480;
}

.badge-container .badge.closed {
  background-color: #168D4C;
}

.badge-container .badge.done {
  background-color: #1755CC;
}

/* 파일 업로드 / 파일 리스트 영역 */
.file-upload-btn-wrap {
  padding-left: 0.7812vw;
}

.file-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20.533rem, auto));
  gap: 2rem;
  margin-top: 4.133rem;
}

.file-item {
  position: relative;
  width: 100%;
  flex-direction: column;
  padding: 1.333rem;
  border-radius: 20px;
  border: 1px solid #C4C4CD;
  background-color: #fff;
}

.file-item:hover {
  border-color: #2E2E38;
}

.file-type-tag {
  display: block;
  width: fit-content;
  padding: 0.266rem 0.933rem;
  border-radius: 110px;
  background-color: #E2E5FE;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.file-info-area {
  margin-top: 1.333rem;
}

.file-info-area .file-name {
  display: block;
  width: 100%;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-info-area .file-upload-time {
  display: block;
  margin-top: 0.133rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.file-description {
  width: 100%;
  height: 42px;
  margin-top: 1.466rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.file-item .btn-delete {
  position: absolute;
  top: 1.333rem;
  right: 1.333rem;
  display: block;
  width: 20px;
  height: 20px;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 15L5 5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 5L5 15" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
}

.image-preview-area {
  padding-top: 2.666rem;
  margin-top: 2.666rem;
}

.image-preview-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(195px, auto));
  gap: 2rem;
}

.image-preview-list .image-item {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 20px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.image-preview-list .image-item>div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.image-preview-list .image-item .image-box {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: unset;
}

/* comment 영역 */
.card.comment .card-body {
  display: flex;
  align-items: stretch;
  padding: 0;
}

.card.comment .comment-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.8rem;
}

.card.comment .comment-title-area h3 {
  margin-bottom: 0;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.card.comment .comment-title-area .total-num {
  min-width: 36px;
  height: 25px;
  padding: 0 0.6rem;
  border-radius: 40px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  text-align: center;
}

.card.comment .comment-area .comment-title-area .total-num {
  background-color: #FFE500;
}

.card.comment .highlight-area .comment-title-area .total-num {
  background-color: #2356F6;
  color: #FFF;
}

.card.comment .comment-area {
  display: flex;
  flex-direction: column;
  width: 65%;
  border-right: 1px solid #DDDDE3;
}

.card.comment .comment-list-wrap {
  flex-grow: 1;
  flex-shrink: 0;
  padding-top: max(2rem, 1.5625vw);
  padding-bottom: max(2rem, 1.5625vw);
  padding-left: 2.666rem;
  padding-right: 2.0833vw;
}

.card.comment .comment-list {
  display: flex;
  flex-direction: column;
  gap: 2.666rem 0;
}

.card.comment .highlight-area {
  width: 35%;
  min-width: 26.133rem;
}

.card.comment .highlight-area .comment-title-area {
  height: 6.4rem;
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.666rem;
  padding-bottom: max(2rem, 1.5625vw);
}

.card.comment .highlight-area .comment-list {
  height: calc(100% - 6.8rem);
  padding-left: 2.0833vw;
  padding-right: calc(2.666rem - 0.933rem);
  overflow-y: auto;
}


/* 하단 버튼 영역 */
.my-schedule-btn-wrap {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.333rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  margin-left: -3.125vw;
  margin-right: -3.125vw;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
}

.my-schedule-btn-wrap.bottom {
  box-shadow: none;
}

.my-schedule-btn-wrap .btn-move-wrap {
  display: flex;
  gap: 0 0.8rem;
}

.my-schedule-btn-wrap .text-container .text {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.my-schedule-btn-wrap .button-container {
  display: flex;
  gap: 0 10px;
  margin: 0;
  padding: 0;
}
</style>